import React, {useRef, useState} from 'react';
import {post} from 'axios';
import {uploadCryptogramFileApi} from "../Api";

function CryptogramUploadFile() {
    const [selectedFile, setSelectedFile] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [postMessage, setpostMessage] = useState();
    const [isSelected, setIsSelected] = useState(false);
    const fileRef = useRef();


    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        const [file] = event.target.files;
        console.log(file);
        setIsSelected(true);
    };

    const handleSubmission = (e) => {
        const formData = new FormData();

        formData.append('file', selectedFile);

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }

        const requestOptions = {
            method: 'POST',
            body: formData,
            mode: 'no-cors',
        };

        /*const response =   fetch(
            `${uploadCryptogramFileApi}`,requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                console.log('Success:', result);
            })
            .catch((error) => {
                console.error('Error:', error);
            });*/

        fetch( `${uploadCryptogramFileApi}`,requestOptions)
            .then(async response => {
                console.log(response)
                const data = await response;

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }
                setpostMessage(data.statusText)
            })
            .catch(error => {
                //this.setState({ errorMessage: error.toString() });
                setErrorMessage(error.toString() )
                console.error('There was an error!', error);
            });
    };


return(
    <div className="row mt-3" >
        <div className="col-md-4">
            <div className="form-group" >
        <label className="control-label">Please, select the file to be upload:</label>
                <p style={{color:"green"}}><strong>{postMessage? "Data Upload SuccessFully" :errorMessage}</strong></p>
        <input  ref={fileRef} className="input-group-file mb-3" type="file" name="file" onChange={changeHandler} />
        {/*{isSelected ? (
            <span></span>
        ) : (
            <p>Select a file to show details</p>
        )}*/}
                <div className="input-group-append">
            <span
                className="input-group-text"
                id="basic-addon2"
                role="button"
                onClick={handleSubmission}
            >
                    Upload
                  </span>
        </div>
            </div>
        </div>
    </div>
)

}
export default CryptogramUploadFile;

